import { useCanadianProvinces, useFormOptions, useUSStates } from '../../../hooks';
import { COUNTRY_OPTIONS } from '../../../hooks/forms/useCountries';

export default function useInsuredFormOptions() {
  const { options: stateOptions } = useUSStates();
  const { options: canadianProvincesOptions } = useCanadianProvinces();
  const insuredStakeholderTypeOptions = [{ value: 'BENEFICIARY', laebl: 'Beneficiary' }];

  return useFormOptions({
    options: [
      { name: 'insuredStakeholderTypes', options: insuredStakeholderTypeOptions },
      { name: 'state', options: stateOptions },
      { name: 'canadianProvinces', options: canadianProvincesOptions },
      { name: 'allStates', options: [...stateOptions, ...canadianProvincesOptions] },
      {
        name: 'country',
        options: COUNTRY_OPTIONS
      }
    ]
  });
}
